module.exports = __webpack_public_path__ + "static/screen-b5a81d3cd8046491e5a1b7a4edf59ef3.png";